import stata from "refractor/stata";
export default stata;